export const Sounds = {
  SELECT_CELL: "select",
  DESELECT_CELL: "deselect",
  FOUND_WORD: "found",
  INVALID_WORD: "invalid",
	REFOUND_WORD: "refound"
};

export async function preloadSounds(audio) {
  await Promise.all([
    audio.load(Sounds.SELECT_CELL, "/sounds/pop1.m4a"),
    audio.load(Sounds.DESELECT_CELL, "/sounds/pop2.m4a"),
    audio.load(Sounds.FOUND_WORD, "/sounds/correct.m4a"),
    audio.load(Sounds.INVALID_WORD, "/sounds/error.m4a"),
    audio.load(Sounds.REFOUND_WORD, "/sounds/refound.m4a")
  ]);
}
